const API_URL = process.env.DROPBOX_API_URL;

const uploadToDropbox = async (file, onProgress) => {
  try {
    // Create form data
    const formData = new FormData();
    formData.append("file", file);

    // Create XMLHttpRequest to track upload progress
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          const progress = (event.loaded / event.total);
          onProgress(progress);
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const response = JSON.parse(xhr.responseText);
          // Format the URL for video embedding if it's a video file
          if (file.type.startsWith('video/')) {
            // Create an embedded video URL that can be used with the YouTube extension
            const videoUrl = `${response.download_url}#t=0.1`;
            resolve(videoUrl);
          } else {
            resolve(response.download_url);
          }
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Upload failed'));
      });

      xhr.addEventListener('abort', () => {
        reject(new Error('Upload aborted'));
      });

      xhr.open('POST', 'https://dropbox-api.onrender.com/upload');
      xhr.send(formData);
    });
  } catch (error) {
    throw new Error("Error uploading file: " + error.message);
  }
};

export default uploadToDropbox;
